/**
 * Created by benon on 2017/10/11.
 */
export default{
  install (Vue, options) {
    Vue.prototype.saveLangType = function (langType) {
      sessionStorage.setItem('uiLang', langType)
      if (langType === 'zh') {
        sessionStorage.setItem('langType', 1)
      } else if (langType === 'tw') {
        sessionStorage.setItem('langType', 2)
      } else if (langType === 'en') {
        sessionStorage.setItem('langType', 3)
      } else if (langType === 'ko') {
        sessionStorage.setItem('langType', 4)
      } else if (langType === 'ja') {
        sessionStorage.setItem('langType', 5)
      }
    }
    Vue.prototype.getLangType = function () {
      let langType = sessionStorage.getItem('langType')
      return langType !== 0 && langType !== null ? langType : 1
    }
    Vue.prototype.setCookie = function (name, value, expireDays) {
      let expDate = new Date()
      expDate.setTime(expDate.getTime() + expireDays * 24 * 60 * 60 * 1000)
      document.cookie = name + '=' + escape(value) + ((expireDays == null) ? '' : ';expires=' + expDate.toGMTString())
      console.log(name + '=' + escape(value) + ((expireDays == null) ? '' : ';expires=' + expDate.toGMTString()))
    }
    Vue.prototype.getCookie = function (name) {
      let arr = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
      let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
      console.log(reg)
      console.log(document.cookie.match(reg))
      if (arr === document.cookie.match(reg)) {
        console.log('has cookie!')
        return unescape(arr[2])
      } else {
        console.log('no cookie!')
        return null
      }
    }
    Vue.prototype.getCookie1 = function (cookieName) {
      let allCookies = document.cookie
      // 索引长度，开始索引的位置
      let cookiePos = allCookies.indexOf(cookieName)
      // 如果找到了索引，就代表cookie存在,否则不存在
      if (cookiePos !== -1) {
        console.log('has cookie')
        // 把cookie_pos放在值的开始，只要给值加1即可
        // 计算取cookie值得开始索引，加的1为“=”
        cookiePos = cookiePos + cookieName.length + 1
        // 计算取cookie值得结束索引
        let cookieEnd = allCookies.indexOf(';', cookiePos)
        if (cookieEnd === -1) {
          cookieEnd = allCookies.length
        }
        // 得到想要的cookie的值
        let value = unescape(allCookies.substring(cookiePos, cookieEnd))
        return value
      }
      console.log('no cookie')
      return null
    }
    Vue.prototype.saveUserInfo = function (userInfo) {
      sessionStorage.setItem('jphUserInfo', JSON.stringify(userInfo))
    }
    // Vue.prototype.getServiceBaseUrl = function () {
    //   let baseUrl = 'http://localhost:8080'
    //   return baseUrl
    // }
    Vue.prototype.showButton = function () {
      let showButton = JSON.parse(sessionStorage.getItem('showButton'))
      return showButton
    }
  }
}




// WEBPACK FOOTER //
// ./src/utils/storage.js